import styled from 'styled-components';
import { colors } from 'Constants/Colors';

export const QuestionContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
  width: auto;
  border-left: 0.4rem solid ${colors.GREEN};
  border-radius: 0.5rem;
  background-color: ${colors.WHITE};
  position: relative;
  padding: 1rem; 2rem;
`;

export const DragContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const QuestionSection = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 1rem;
  height: 20%;
`;

export const QuestionFooter = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 1rem;
`;

export const FloatingTrashButton = styled.div`
  position: absolute;
  right: 1rem;
  color: ${colors.GRAY_DARK};
  cursor: pointer;
`;

export const FloatingAddButton = styled.div`
  position: absolute;
  right: -1.5rem;
  bottom: -1.5rem;
  cursor: pointer;
`;

export const horizontalDrag = {
  transform: 'rotate(90deg)',
  color: colors.GRAY_DARK,
  pointer: 'grab',
};

export const questionTextInput = {
  width: '57.5%',
};

export const questionSelectInput = {
  minWidth: '40%',
};

export default {
  QuestionContainer,
  DragContainer,
  QuestionSection,
  QuestionFooter,
  FloatingTrashButton,
  FloatingAddButton,
  horizontalDrag,
  questionTextInput,
  questionSelectInput,
};
